import { useDataChange } from 'Simple/Data.js'
import View from './view.js'

export default function Logic(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'search',
  })
  let changeCitySearch = useDataChange({
    viewPath: props.viewPath,
    context: 'city_search',
    path: 'term',
  })

  let onChooseAddress = ({ street, city, state, zip }) => {
    change(next => {
      next.other.external_office.postal_address.address_line1 = street || ''
      next.other.external_office.postal_address.city = city || ''
      next.other.external_office.postal_address.state = state || ''
      next.other.external_office.postal_address.zip = zip || ''
    })
    changeCitySearch(city || '')
  }

  return <View {...props} onChooseAddress={onChooseAddress} />
}
